import { gql } from '@apollo/client';

export const UPDATE_SETTING_VALUE = gql`
  mutation setSetting($input: UpdateSettingInput!) {
    setSetting(input: $input) {
      alias
      updated_at
      value
    }
  }
`;

export const UPDATE_MULTIPLE_SETTING_VALUE = gql`
  mutation SetSettings($input: UpdateMultipleSettingsInput!) {
    setSettings(input: $input) {
      value
      id
      alias
      updated_at
    }
  }
`;

export const GET_SETTINGS_VALUE = gql`
  query settingValues {
    settingValues {
      alias
      value
      updated_at
      disabled
    }
    currencies {
      id
      title
      letter
      alias
    }
  }
`;

export const SET_CLOUD_PAYMENTS = gql`
  mutation setCloudPaymentsAccountToCompany(
    $input: SetCloudPaymentsAccountToCompanyInput!
  ) {
    setCloudPaymentsAccountToCompany(input: $input) {
      publicId
    }
  }
`;

const BeneficiaryFragment = gql`
  fragment Beneficiary on Beneficiary {
    balance
    created_at
    email
    error
    full_name
    id
    inn
    opf
    organization_id
    phone
    status
    type
  }
`;

export const GET_BENEFICIARIES = gql`
  ${BeneficiaryFragment}
  query getBeneficiaries {
    getBeneficiaries {
      ...Beneficiary
    }
  }
`;

export const GET_CURRENT_BENEFICIARY = gql`
  ${BeneficiaryFragment}
  query getCurrentBeneficiary {
    getCurrentBeneficiary {
      ...Beneficiary
    }
  }
`;

export const CONNECT_PAYMENT_SERVICES = gql`
  mutation connectPaymentService(
    $input: ConnectPaymentServiceInput!
    $service: IntegrationService!
  ) {
    connectPaymentService(input: $input, service: $service)
  }
`;

export const DISCONNECT_PAYMENT_SERVICE = gql`
  mutation DisconnectPaymentService($service: IntegrationService!) {
    disconnectPaymentService(service: $service)
  }
`;
